import React from 'react';
import { PRICE, PRICE_BEFORE } from '../data/matematik';

/**
 * Honest announcement bar: no fake timers or counters.
 */
export function CountdownBar() {
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-56" data-mp="3084m9i3jlhs0">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-xs sm:text-sm" data-id="element-57" data-mp="2vcpacvp3hvy8">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-58" data-mp="2mewwzx2xoydh">
          <span className="relative inline-flex h-2 w-2 rounded-full bg-red-300" data-id="element-59" data-mp="2hfajdmj71g45" />
        </span>
        <span className="text-stone-50/80" data-id="element-60" data-mp="2cg7nosp3sm8u">
          <span className="hidden sm:inline" data-id="element-61" data-mp="2ch91v61f1ous">Introduktionspris </span>
          <span className="sm:hidden" data-id="element-62" data-mp="28f47u6722q7m">Nu: </span>
        </span>
        <span className="font-semibold text-stone-50" data-id="element-63" data-mp="28gp4c1cxkj84">{PRICE}</span>
        <s className="text-stone-50/50" data-id="element-64" data-mp="anjhqbl2rkpd">{PRICE_BEFORE}</s>
        <span className="hidden text-stone-50/80 sm:inline" data-id="element-65" data-mp="6nirltom5l2h">· Engangsbetaling · 7 dages tilfredshedsgaranti</span>
      </div>
    </div>;
}